import { ReactNode } from 'react';

import { Props as LayoutContainerProps } from 'components/layout/LayoutContainer';

import Component from './component';

export interface Props {
    background?: {
        desktop: [
            {
                href: string;
            },
        ],
        mobile: [
            {
                href: string;
            },
        ],
    };
    layoutContainerProps?: LayoutContainerProps;
    underline?: string;
    headline?: string;
    subheadline?: string;
    infoHeadline?: string;
    children?: ReactNode;
}

Component.defaultProps = {
    background: null,
    layoutContainerProps: null,
    underline: null,
    headline: null,
    subheadline: null,
    children: null,
};

export default Component;